<template>
  <div class="d d_xm">
    <headers :goBack="goBack" :isForm="1" />
    <div class="title">
      基层学校少先队信息统计
      <div class="tip">（由学校大队辅导员填写）</div>
    </div>
    <van-form
      @submit="onClickButtonSubmit"
      validate-trigger="onSubmit"
      @failed="handleFailed"
    >
    <div class="kuang">
      <van-cell 
        class="custom-cell-title"
        title="（一）基本信息"
      />
      <diy-picker
        title="学校类型"
        :value="states.schoolTypeTxt"
        :list="schoolTypeList"
        :handlerSelect="selectSchooleType"
        :isClick="true"
        :isRequired="schoolTypeFlag"
      />
      <diy-picker
        title="学校所处区域"
        :value="states.schoolAreaTxt"
        :list="schoolAreaList"
        :handlerSelect="selectSchooleArea"
        :isClick="true"
        :isRequired="schoolAreaFlag"
      />
      <van-cell
        class="custom-cell-title"
        title="（二）少先队组织信息"
      />
      <van-field
        class="d_f"
          required
          v-model="states.zhongDuiNum"
          @blur="onBlur"
          clearable
          label="中队数量"
          placeholder="请输入"
          type="number"
          @paste.prevent
          :rules="[{ required: true, message: '请输入中队数量' },{ validator: (value) => Number(value) >= 0 && Number(value) <= 500,  // 核心验证逻辑
            message: '限制填写数量0至500，请注意', 
            trigger: 'onBlur'
          }]"
        />
        <van-field
         class="d_f"
          required
          v-model="states.zhongDuiNumSure"
          clearable
          label="确认中队数量"
          placeholder="请输入"
          type="number"
          @paste.prevent
          :rules="[{ required: true, message: '请确认中队数量' }]"
          :error="zhongDuiInputsDifferent"
          :error-message="zhongDuiErrorMessage"
          @blur="zhongDuiValidateInputs"
        />
        <van-field
         class="d_f"
          required
          v-model="states.shaoXianDuiPeopleNum"
          @blur="onBlur"
          clearable
          label="少先队员人数"
          placeholder="请输入"
          type="number"
          @paste.prevent
          :rules="[{ required: true, message: '请输入少先队员人数' }]"
        />
        <van-field
         class="d_f"
          required
          v-model="states.shaoXianDuiPeopleNumSure"
          clearable
          label="确认少先队员人数"
          placeholder="请输入"
          type="number"
          @paste.prevent
          :rules="[{ required: true, message: '请确认少先队员人数' }]"
          :error="shaoXianDuiInputsDifferent"
          :error-message="shaoXianDuiErrorMessage"
          @blur="shaoXianDuiValidateInputs"
        />
        <van-field
         class="d_f"
          required
          v-model="states.schoolGradePeopleNum"
          @blur="onSchoolGradePeopleNumBlur"
          :error="schoolGradePeopleNumErr"
          :error-message="schoolGradePeopleNumErrorMessage"
          clearable
          :label="'本校' + states.schoolGradeName + '学生数'+ ((states.schoolTypeKey == 2 || states.schoolTypeKey == 5) ? '（初中段四年制的按6-9年级统计）' : '')" 
          placeholder="请输入"
          type="number"
          @paste.prevent
          :rules="[{ required: true, message: '请输入本校' + states.schoolGradeName + '学生数' }]"
        />
        <van-field
         class="d_f"
          required
          v-model="states.schoolGradePeopleNumSure"
          clearable
          :label="'确认本校' + states.schoolGradeName + '学生数'+ ((states.schoolTypeKey == 2 || states.schoolTypeKey == 5) ? '（初中段四年制的按6-9年级统计）' : '')" 
          placeholder="请输入"
          type="number"
          @paste.prevent
          :rules="[{ required: true, message: '请确认本校' + states.schoolGradeName + '学生数' }]"
          :error="schoolGradePeopleInputsDifferent"
          :error-message="schoolGradePeopleErrorMessage"
          @blur="schoolGradePeopleValidateInputs"
        />
        <van-field
          required
          name="radio"
          label="最近一次少代会召开时间"
          class="radioFlex d_f"
          :rules="[{ required: true, message: '请选择最近一次少代会召开时间' }]"
        >
          <template #input>
            <van-radio-group
              v-model="states.sdhDate"
              direction="horizontal"
              v-for="item in SdhList"
              v-bind:key="item.key"
            >
              <van-radio 
                :name="item.key" 
                checked-color="#ff6865"
                @click="handleRadioChange(item.key)">
                {{
                  item.value
                }}
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <DatePickerPopup
          v-model:show="isDatePickerVisible"
          :title="'选择日期'"
          type="year-month"
          :callback="(val) => handlerSelect('meetingData', val)"
          @cancel="handleCancel"
          :maxDate="new Date(2024, 11, 31)"
        />

        <!-- 学校类型选择“初中”和“完全中学”后，隐藏此项 -->
        <diy-picker
          v-if="states.schoolTypeKey != 2 && states.schoolTypeKey != 5"
          title="学校学生分几批次入队"
          :value="states.ruduiPiciTxt"
          :list="ruduiPiciList"
          :handlerSelect="selectRuduiPici"
          :isClick="true"
          :isRequired="ruduiPiciFlag"
        />

        <van-field
          name="radio"
          label="学校开展“红领巾奖章”争章活动情况"
          class="radioFlex d_f"
          required
          :rules="[{ required: true, message: '请选择学校开展“红领巾奖章”争章活动情况' }]"
        >
          <template #input>
            <van-radio-group
              v-model="states.isHljJzActivity"
              @change="handleHljJzRadioChange"
              direction="horizontal"
              v-for="item in yORn"
              v-bind:key="item.key"
            >
              <van-radio :name="item.key" checked-color="#ff6865">{{
                item.value
              }}</van-radio>
            </van-radio-group>
          </template>
        </van-field>

         <!-- 学校类型选择“初中”和“完全中学”后，隐藏此项 -->
        <van-field
          v-if="states.schoolTypeKey != 2 && states.schoolTypeKey != 5"
          name="radio"
          label="学生入队时首次佩戴的红领巾是否由学校配发"
          class="radioFlex d_f"
          required
          :rules="[{ required: true, message: '请选择学生入队时首次佩戴的红领巾是否由学校配发' }]"
        >
          <template #input>
            <van-radio-group
              v-model="states.isHljPeiFa"
              @change="handleHljPeiFaRadioChange"
              direction="horizontal"
              v-for="item in yORn"
              v-bind:key="item.key"
            >
              <van-radio :name="item.key" checked-color="#ff6865">{{
                item.value
              }}</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          required
          name="radio"
          label="是否有少先队队室"
          class="radioFlex d_f"
          :rules="[{ required: true, message: '请选择是否有少先队队室' }]"
        >
          <template #input>
            <van-radio-group
              v-model="states.sxdClassDate"
              direction="horizontal"
              v-for="item in SxdClassList"
              v-bind:key="item.key"
            >
              <van-radio 
                :name="item.key" 
                checked-color="#ff6865"
                @click="handleSxdClassRadioChange(item.key)">
                {{
                  item.value
                }}
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <SelectPopup
          ref="selectRef"
          :list="sxdClassMList"
          :handlerSelect="selectSxdClass"
          :isClick="true"
           @cancel="handleSxdClassCancel"
           @close="handleSxdClassCancel"
        />
        <van-field
          required
          name="radio"
          label="是否有少先队鼓号队"
          class="radioFlex d_f"
          :rules="[{ required: true, message: '请选择是否有少先队鼓号队' }]"
        >
          <template #input>
            <van-radio-group
              v-model="states.sxdGhdDate"
              direction="horizontal"
              v-for="item in SxdGhdList"
              v-bind:key="item.key"
            >
              <van-radio 
                :name="item.key" 
                checked-color="#ff6865"
                @click="handleSxdGhdRadioChange(item.key)">
                {{
                  item.value
                }}
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <SelectPopup
          ref="selectGhdRef"
          :list="sxdGhdPopList"
          :handlerSelect="selectSxdGhd"
          :isClick="true"
          @cancel="handleSxdGhdCancel"
          @close="handleSxdGhdCancel"
        />
        <van-cell
          title="*根据《中国少年先锋队鼓号队建设标准（试行）》规定，大型鼓号队编制66人，中型鼓号队编制33人，小型鼓号队编制17人。"
        />
        <diy-picker
          title="少先队活动课课时安排情况"
          :value="states.sxdHdkTxt"
          :list="sxdHdkList"
          :handlerSelect="selectSxdHdk"
          :isClick="true"
          :isRequired="sxdHdkFlag"
        />
        <van-cell 
          class="custom-cell-title"
          title="（三）学校少工委主任信息"
        />
        <diy-picker
          title="学校少工委主任由谁来担任"
          :value="states.sgwZhuRenTxt"
          :list="sgwZhuRenList"
          :handlerSelect="selectSgwZhuRen"
          :isClick="true"
          :isRequired="sgwZhuRenFlag"
        />
        <template v-if="states.sgwZhuRenkey != 6">
          <van-field
          class="d_f"
            required
            v-model="states.sgwZhuRenName"
            @blur="onBlur"
            clearable
            label="学校少工委主任姓名"
            placeholder="请输入"
            :rules="[{ required: true, message: '请输入学校少工委主任姓名' }]"
          />
          <van-field
          class="d_f"
            required
            v-model="states.sgwZhuRenNameSure"
            clearable
            label="确认学校少工委主任姓名"
            placeholder="请输入"
            :rules="[{ required: true, message: '请确认学校少工委主任姓名' }]"
            :error="sgwZhuRenNameInputsDifferent"
            :error-message="sgwZhuRenNameErrorMessage"
            @blur="sgwZhuRenNameValidateInputs"
          />
          <diy-picker
            title="政治面貌"
            :value="states.zzmmTxt"
            :list="zzmmList02"
            :handlerSelect="selectZzmm"
            :isClick="true"
            :isRequired="zzmmFlag"
          />
          <van-field
          class="d_f"
          required
          v-model="states.phone"
          clearable
          label="手机号"
          placeholder="请输入手机号"
          type="number"
          maxlength="11"
          :rules="[{ required: true, message: '请填写手机号' },
            {
              validator: (val) => val.length === 11,
              message: '请输入11位手机号'
            }
          ]"
          :error="PhoneFormatDifferent"
          :error-message="errorMessagePhoneFormat"
          @blur="validateInputsPhoneFormat"
        />
        <van-field
          class="d_f"
          required
          v-model="states.phoneSure"
          clearable
          label="确认手机号"
          placeholder="请确认手机号"
          type="number"
          maxlength="11"
          :rules="[{ required: true, message: '请确认手机号' }]"
          :error="phoneDifferent"
          :error-message="errorMessagePhone"
          @blur="validateInputsPhone"
          @paste.prevent
        />
      </template>

      <van-cell 
        class="custom-cell-title"
        title="（四）大队辅导员信息"
      />
      <diy-picker
        title="大队辅导员身份类型"
        :value="states.daDuiFdyTpyeTxt"
        :list="daDuiFdyTpyeList"
        :handlerSelect="selectDaDuiFdyTpye"
        :isClick="true"
        :isRequired="daDuiFdyTpyeFlag"
      />
      <van-field
      class="d_f"
        required
        v-model="states.daDuiFdyName"
        clearable
        label="姓名"
        placeholder="请输入姓名"
        :rules="[{ required: true, message: '请填写姓名' }]"
      />
      <van-field
      class="d_f"
        required
        v-model="states.daDuiFdyIdCard"
        clearable
        label="身份证号"
        placeholder="请输入身份证号"
        maxlength="18"
        :rules="[{ required: true, message: '请填写身份证号' },
          {
            validator: validateIdCard,
            message: '请输入合法的18位身份证号'
          }
        ]"
        :error="idCardFormatDifferent"
        :error-message="errorMessageIdCardFormat"
        @blur="validateInputIdCardFormat"
      />
      <van-field
      class="d_f"
        required
        v-model="states.daDuiFdyIdCardSure"
        clearable
        label="确认身份证号"
        placeholder="请确认身份证号"
        maxlength="18"
        :rules="[{ required: true, message: '请确认身份证号' }]"
        :error="idCardDifferent"
        :error-message="errorMessageIdCard"
        @blur="validateInputsIdCard"
        @paste.prevent
      />
      <van-field
        required
        name="radio"
        label="性别"
        class="radioFlex d_f"
        :rules="[{ required: true, message: '请选择性别' }]"
      >
        <template #input>
          <van-radio-group
            v-model="states.daDuiFdySex"
            direction="horizontal"
            v-for="item in sexs"
            v-bind:key="item.key"
          >
            <van-radio :name="item.key" checked-color="#ff6865">{{
              item.value
            }}</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <datetime-picker
        :value="states.daDuiFdyBirthday"
        title="出生年月"
        type="year-month"
        :callback="(val) => handlerDaDuiFdySelect('birthday', val)"
        :isRequired="birthdayFlag"
      />
      <diy-picker
        title="政治面貌"
        :value="states.daDuiFdyZzmmTxt"
        :list="zzmmList01"
        :handlerSelect="selectDaDuiFdyZzmm"
        :isClick="true"
        :isRequired="daDuiFdyZzmmFlag"
      />
      <van-field
       class="d_f"
        required
        v-model="states.daDuiFdyPhone"
        clearable
        label="手机号"
        placeholder="请输入手机号"
        type="number"
        maxlength="11"
        :rules="[{ required: true, message: '请填写手机号' },
          {
            validator: (val) => val.length === 11,
            message: '请输入11位手机号'
          }
        ]"
        :error="daDuiFdyPhoneFormatDifferent"
        :error-message="errorMessageDaDuiFdyPhoneFormat"
        @blur="validateInputsDaDuiFdyPhoneFormat"
      />
      <van-field
       class="d_f"
        required
        v-model="states.daDuiFdyPhoneSure"
        clearable
        label="确认手机号"
        placeholder="请确认手机号"
        type="number"
        maxlength="11"
        :rules="[{ required: true, message: '请确认手机号' }]"
        :error="daDuiFdyPhoneDifferent"
        :error-message="errorMessagedaDuiFdyPhone"
        @blur="validateInputsdaDuiFdyPhone"
        @paste.prevent
      />
      <van-field
        name="radio"
        label="是否师范生"
        class="radioFlex d_f"
        required
        :rules="[{ required: true, message: '请选择是否师范生' }]"
      >
        <template #input>
          <van-radio-group
            v-model="states.isSfs"
            @change="handleSfsRadioChange"
            direction="horizontal"
            v-for="item in yORn"
            v-bind:key="item.key"
          >
            <van-radio :name="item.key" checked-color="#ff6865">{{
              item.value
            }}</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <diy-picker
        title="全日制教育学历"
        :value="states.eduTxt"
        :list="eduList01"
        :handlerSelect="selectEdu"
        :isClick="true"
        :isRequired="eduFlag"
      />
      <diy-picker
        title="所学专业大类"
        :value="states.majorTxt"
        :list="majorList"
        :handlerSelect="selectMajor"
        :isClick="true"
        :isRequired="majorFlag"
      />
      <van-field
        name="radio"
        label="毕业院校是否为港澳台或国外院校"
        class="radioFlex d_f"
        required
        :rules="[{ required: true, message: '请选择毕业院校是否为港澳台或国外院校' }]"
      >
        <template #input>
          <van-radio-group
            v-model="states.isGatOrAbroad"
            direction="horizontal"
            v-for="item in yORn"
            v-bind:key="item.key"
          >
            <van-radio 
              :name="item.key" 
              checked-color="#ff6865"
              @click="handleGatOrAbroadRadioChange(item.key)"
            >{{
              item.value
            }}</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <school v-if="states.isGatOrAbroad == 2 && states.collegeKey != -1"
        title="毕业院校"
        :value="states.collegeTxt"
        :handlerSelect="selectCollege"
        :isClick="true"
        :isRequired="collegeFlag"
      />
      <van-field v-if="states.isGatOrAbroad == 1 || states.collegeKey == -1"
      class="d_f"
        required
        v-model="states.collegeTxt"
        clearable
        label="毕业院校"
        placeholder="请输入毕业院校"
        :rules="[{ required: true, message: '请填写毕业院校' }]"
      />
      <diy-picker
        title="最高教育学历"
        :value="states.highestEduTxt"
        :list="highestEduList"
        :handlerSelect="selectHighestEdu"
        :isClick="true"
        :isRequired="highestEduFlag"
      />
      <template v-if="states.highestEduKey == 2 || states.highestEduKey == 3 || states.highestEduKey == 4 || states.highestEduKey == 5 || states.highestEduKey == 6">
        <diy-picker
          title="所学专业大类"
          :value="states.highestMajorTxt"
          :list="majorList"
          :handlerSelect="selectHighestMajor"
          :isClick="true"
          :isRequired="highestMajorFlag"
        />
        <van-field
          name="radio"
          label="毕业院校是否为港澳台或国外院校"
          class="radioFlex d_f"
          required
          :rules="[{ required: true, message: '请选择毕业院校是否为港澳台或国外院校' }]"
        >
          <template #input>
            <van-radio-group
              v-model="states.isHighestGatOrAbroad"
              direction="horizontal"
              v-for="item in yORn"
              v-bind:key="item.key"
            >
              <van-radio 
                :name="item.key" 
                checked-color="#ff6865"
                @click="handleHighestGatOrAbroadRadioChange(item.key)"
              >{{
                item.value
              }}</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <school v-if="states.isHighestGatOrAbroad == 2 && states.highestCollegeKey != -1"
          title="毕业院校"
          :value="states.highestCollegeTxt"
          :handlerSelect="selectHighestCollege"
          :isClick="true"
          :isRequired="highestCollegeFlag"
        />
        <van-field v-if="states.isHighestGatOrAbroad == 1 || states.highestCollegeKey == -1"
        class="d_f"
          required
          v-model="states.highestCollegeTxt"
          clearable
          label="毕业院校"
          placeholder="请输入毕业院校"
          :rules="[{ required: true, message: '请填写毕业院校' }]"
        />
        <diy-picker
          title="最高教育学历性质"
          :value="states.highestEduXZTxt"
          :list="highestEduXZList"
          :handlerSelect="selectHighestEduXZ"
          :isClick="true"
          :isRequired="highestEduXZFlag"
        />
      </template>
      <van-field
        name="radio"
        label="学校是否成立团组织"
        class="radioFlex d_f"
        required
        :rules="[{ required: true, message: '请选择学校是否成立团组织' }]"
      >
        <template #input>
          <van-radio-group
            v-model="states.isHaveTuan"
            @change="handleHaveTuanRadioChange"
            direction="horizontal"
            v-for="item in yORn"
            v-bind:key="item.key"
          >
            <van-radio :name="item.key" checked-color="#ff6865">{{
              item.value
            }}</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field v-if="states.isHaveTuan && states.isHaveTuan == 1"
        name="radio"
        label="是否兼任校内团干部职务"
        class="radioFlex d_f"
        required
        :rules="[{ required: true, message: '请选择是否兼任校内团干部职务' }]"
      >
        <template #input>
          <van-radio-group
            v-model="states.isHaveTuanJob"
            @change="handleHaveTuanJobRadioChange"
            direction="horizontal"
            v-for="item in yORn"
            v-bind:key="item.key"
          >
            <van-radio :name="item.key" checked-color="#ff6865">{{
              item.value
            }}</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <diy-picker v-if="states.isHaveTuanJob && states.isHaveTuanJob == 1"
        title="兼任校内团干部职务"
        :value="states.haveTuanJobMajorTxt"
        :list="haveTuanJobMajorList"
        :handlerSelect="selectHaveTuanJobMajor"
        :isClick="true"
        :isRequired="haveTuanJobMajorFlag"
      />
      <datetime-picker
        :value="states.fdyStartTime"
        title="任本校大队辅导员开始时间"
        type="year-month"
        :callback="(val) => handlerFdyStartTimeySelect('fdyStartTime', val)"
        :isRequired="fdyStartTimeFlag"
      />
      <van-field
        class="d_f"
        required
        v-model="states.sxdJobDur"
        clearable
        label="累计从事少先队工作年数（精确到0.5年）"
        placeholder="请输入"
        :rules="[{ required: true, message: '请填写累计从事少先队工作年数' }]"
      />
      <van-field
        class="d_f"
        required
        v-model="states.sxdJobDurSure"
        clearable
        label="确认累计从事少先队工作年数（精确到0.5年）"
        placeholder="请确认"
        :rules="[{ required: true, message: '请确认累计从事少先队工作年数' }]"
        :error="sxdJobDurDifferent"
        :error-message="errorMessageSxdJobDur"
        @blur="validateInputSxdJobDur"
      />
      <van-field
        name="radio"
        label="是否有担任中队辅导员的经历"
        class="radioFlex d_f"
        required
        :rules="[{ required: true, message: '请选择是否有担任中队辅导员的经历' }]"
      >
        <template #input>
          <van-radio-group
            v-model="states.isHaveZdFdyJob"
            @change="handleHaveZdFdyJobRadioChange"
            direction="horizontal"
            v-for="item in yORn"
            v-bind:key="item.key"
          >
            <van-radio :name="item.key" checked-color="#ff6865">{{
              item.value
            }}</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <template v-if="states.isHaveZdFdyJob && states.isHaveZdFdyJob == 1">
        <datetime-picker
          :value="states.zdFdyStartTime"
          title="担任中队辅导员开始时间"
          type="year-month"
          :callback="(val) => handlerZdFdyStartTimeSelect('zdFdyStartTime', val)"
          :isRequired="zdFdyStartTimeFlag"
        />
        <datetime-picker
          :value="states.zdFdyEndTime"
          title="担任中队辅导员结束时间"
          type="year-month"
          :callback="(val) => handlerZdFdyEndTimeSelect('zdFdyEndTime', val)"
          :isRequired="zdFdyStartTimeFlag"
        />
      </template>
      <diy-picker
        title="校内职务"
        :value="states.schoolMajorTxt"
        :list="schoolMajorList"
        :handlerSelect="selectSchoolMajor"
        :isClick="true"
        :isRequired="schoolMajorFlag"
      />
      <diy-picker v-if="states.schoolMajorKey && (states.schoolMajorKey == 4 || states.schoolMajorKey == 5 || states.schoolMajorKey == 6)"
        title="享受待遇"
        :value="states.salaryTxt"
        :list="salaryList"
        :handlerSelect="selectSalary"
        :isClick="true"
        :isRequired="salaryFlag"
      />
      <diy-picker
        title="职称"
        :value="states.titleTxt"
        :list="jobTitleList"
        :handlerSelect="selectTitle"
        :isClick="true"
        :isRequired="titleFlag"
      />
      <diy-picker
        title="任教学科门数"
        :value="states.teachSubjectNumTxt"
        :list="teachSubjectNumList"
        :handlerSelect="selectTeachSubjectNum"
        :isClick="true"
        :isRequired="teachSubjectNumFlag"
      />
      <SelectMultiple v-if="states.teachSubjectNumKey != 1"
        title="任教学科"
        :value="states.teachSubjectsKeyArray"
        :list="teachSubjectsList"
        :handlerSelect="selectTeachSubjects"
        :isClick="true"
        :isRequired="teachSubjectsFlag"
      />
      <van-field v-if="states.isHasOtherTeachSubjects && states.isHasOtherTeachSubjects == true"
       class="d_f"
        required
        v-model="states.otherTeachSubject"
        clearable
        label="其他任教学科名称"
        placeholder="请确认其他任教学科名称"
        :rules="[{ required: true, message: '请输入其他任教学科名称' }]"
      />
      <van-field
       class="d_f"
        required
        v-model="states.classHourNum"
        clearable
        label="每周课时数"
        placeholder="请输入每周课时数"
        type="number"
        @paste.prevent
        :rules="[{ required: true, message: '请填写每周课时数' },
          { validator: (value) => Number(value) <= 20,  // 核心验证逻辑
            message: '数量超过20，请注意', 
            trigger: 'onBlur'
          }
        ]"
      />
      <van-field
       class="d_f"
        required
        v-model="states.classHourNumSure"
        clearable
        label="确认每周课时数"
        placeholder="请确认每周课时数"
        type="number"
        @paste.prevent
        :rules="[{ required: true, message: '请确认每周课时数' }]"
        :error="classHourNumDifferent"
        :error-message="errorMessageClassHourNum"
        @blur="validateInputClassHourNum"
      />
      <van-field
       class="d_f"
        required
        v-model="states.zdFdyPxNum"
        clearable
        label=""
        placeholder="请输入2024年度本校中队辅导员参加线下少先队相关培训的人数"
        type="number"
        @paste.prevent
        :rules="[{ required: true, message: '请填写2024年度本校中队辅导员参加线下少先队相关培训的人数' },{ validator: (value) => Number(value) >= 0 && Number(value) <= 500,  // 核心验证逻辑
            message: '限制填写数量0至500，请注意', 
            trigger: 'onBlur'
          }]"
      >
        <template #label>
          <span>2024年度本校中队辅导员参加<span class="fz-bold">线下</span>少先队相关培训的人数</span>
          </template>
      </van-field>
      
      <van-field
       class="d_f"
        required
        v-model="states.zdFdyPxNumSure"
        clearable
        label=""
        placeholder="请确认2024年度本校中队辅导员参加线下少先队相关培训的人数"
        type="number"
        @paste.prevent
        :rules="[{ required: true, message: '请确认2024年度本校中队辅导员参加线下少先队相关培训的人数' }]"
        :error="zdFdyPxDifferent"
        :error-message="errorMessageZdFdyPx"
        @blur="validateInputZdFdyPx"
        >
        <template #label>
          <span>确认2024年度本校中队辅导员参加<span class="fz-bold">线下</span>少先队相关培训的人数</span>
          </template>
      </van-field>




      <van-field
       class="d_f"
        required
        v-model="states.zdFdyPxXsNum"
        clearable
        label=""
        placeholder="请输入2024年度本校中队辅导员参加互联网线上少先队相关培训的人数"
        type="number"
        @paste.prevent
        :rules="[{ required: true, message: '请填写2024年度本校中队辅导员参加互联网线上少先队相关培训的人数' },{ validator: (value) => Number(value) >= 0 && Number(value) <= 500,  // 核心验证逻辑
            message: '限制填写数量0至500，请注意', 
            trigger: 'onBlur'
          }]"
      >
        <template #label>
          <span>2024年度本校中队辅导员参加<span class="fz-bold">互联网线上</span>少先队相关培训的人数</span>
          </template>
      </van-field>
      <van-field
       class="d_f"
        required
        v-model="states.zdFdyPxXsNumSure"
        clearable
        label=""
        placeholder="请输入2024年度本校中队辅导员参加互联网线上少先队相关培训的人"
        type="number"
        @paste.prevent
        :rules="[{ required: true, message: '请确认2024年度本校中队辅导员参加互联网线上少先队相关培训的人数' }]"
        :error="zdFdyPxXsDifferent"
        :error-message="errorMessagezdFdyPxXs"
        @blur="validateInputZdFdyPxXs"
        >
        <template #label>
          <span>确认2024年度本校中队辅导员参加<span class="fz-bold">互联网线上</span>少先队相关培训的人数</span>
          </template>
      </van-field>

    <van-field
      required
      name="radio"
      label="本校除上述已经填报的大队辅导员以外，是否还设有副大队辅导员。（分校区大队辅导员，分设中学部、小学部的大队辅导员等均纳入本次副大队辅导员人数统计）"
      class="radioFlex d_f"
      :rules="[{ required: true, message: '请选择是否还设有副大队辅导员' }]"
    >
      <template #input>
        <van-radio-group
          v-model="states.fDaDuifdy"
          direction="horizontal"
          v-for="item in FDaDuifdyList"
          v-bind:key="item.key"
        >
          <van-radio 
            :name="item.key" 
            checked-color="#ff6865"
            @click="handleFDaDuifdyRadioChange(item.key)">
            {{
              item.value
            }}
          </van-radio>
        </van-radio-group>
      </template>
    </van-field>
    <SelectPopup
      ref="fDaDuifdySelectRef"
      :list="fDaDuifdyMList"
      :handlerSelect="selectfDaDuifdy"
      :isClick="true"
      @cancel="handleFDaDuifdyCancel"
      @close="handleFDaDuifdyCancel"
    />




    </div>
      <!--登录按钮-->
      <div style="margin: 16px">
        <van-button round block type="primary" native-type="submit" class="btn btn_dl">
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted,getCurrentInstance } from "vue";
import headers from "../../../components/Header.vue";
import diyPicker from "@/components/Select";
import { useRoute, useRouter } from "vue-router";
import DatePickerPopup from "../../../components/DatePickerPopup.vue";
import { format } from "@/common/js/utils";
import SelectPopup from "../../../components/SelectPopup.vue";
import datetimePicker from "@/components/DatePicker";
import school from "@/components/School"
import { tipsMsg, getKey, encrypt, rsaUtil, serverPublicKey } from "../../../common/js";
import SelectMultiple from "../../../components/SelectMultiple.vue";
import { addForm, editForm, getsubmitData } from "../../../service/form";
import { Dialog } from "vant";
import {
  schoolTypeList,
  schoolAreaList,
  ruduiPiciList,
  yORn,
  sxdClassMList,
  sxdGhdPopList,
  sxdHdkList,
  sgwZhuRenList,
  zzmmList02,
  daDuiFdyTpyeList,
  sexs,
  zzmmList01,
  eduList01,
  majorList,
  highestEduList,
  highestEduXZList,
  haveTuanJobMajorList,
  schoolMajorList,
  salaryList,
  jobTitleList,
  teachSubjectNumList,
  teachSubjectsList,

  fDaDuifdyMList,


} from "@/common/js/field";
const route = useRoute();
const router = useRouter();
const { proxy } = getCurrentInstance();
const states = reactive({
  schoolTypeTxt: '请选择',
  schoolTypeKey: null,
  schoolAreaTxt: '请选择',
  schoolAreaKey: null,
  zhongDuiNum: null,
  zhongDuiNumSure: null,
  shaoXianDuiPeopleNum: null,
  shaoXianDuiPeopleNumSure: null,
  schoolGradeName: 'x-x年级',
  schoolGradePeopleNum: null,
  schoolGradePeopleNumSure: null,
  sdhDate: null,
  sdhDateTxt: null,
  ruduiPiciTxt: '请选择',
  ruduiPiciKey: null,
  isHljJzActivity: null,
  //  isHljJzActivityTxt: format(states.isHljJzActivity, 1),
  isHljJzActivityTxt: null,
  isHljPeiFa: null,
  isHljPeiFaTxt: null,
  sxdClassDate: null,
  sxdClassDateTxt: null,
  sxdGhdDate: null,
  sxdGhdDateTxt: null,
  sxdHdkTxt: '请选择',
  sxdHdkKey: null,
  sgwZhuRenTxt: '请选择',
  sgwZhuRenkey: null,
  sgwZhuRenName: null,
  sgwZhuRenNameSure: null,
  zzmmTxt: '请选择',
  zzmmkey: null,
  phone: null,
  phoneSure: null,
  daDuiFdyTpyeTxt: '请选择',
  daDuiFdyTpyeKey: null,
  daDuiFdyName: null,
  daDuiFdyIdCard: null,
  daDuiFdyIdCardSure: null,
  daDuiFdySex: null,
  daDuiFdySexTxt: null,
  daDuiFdyBirthday: null,
  daDuiFdyZzmmTxt: '请选择',
  daDuiFdyZzmmKey: null,
  daDuiFdyPhone: null,
  daDuiFdyPhoneSure: null,
  isSfs: null,
  isSfsTxt: null,
  eduKey: null,
  eduTxt: '请选择',
  majorKey: null,
  majorTxt: '请选择',
  isGatOrAbroad: null,
  isGatOrAbroadTxt: null,
  collegeKey: null,
  collegeTxt: '请选择',
  highestEduKey: null,
  highestEduTxt: '请选择',
  highestMajorKey: null,
  highestMajorTxt: '请选择',
  highestCollegeKey: null,
  highestCollegeTxt: '请选择',
  highestEduXZKey: null,
  highestEduXZTxt: '请选择',
  isHighestGatOrAbroad: null,
  isHighestGatOrAbroadTxt: null,
  isHaveTuan: null,
  isHaveTuanTxt: null,
  isHaveTuanJob: null,
  isHaveTuanJobTxt: null,
  haveTuanJobMajorKey: null,
  haveTuanJobMajorTxt: '请选择',
  fdyStartTime: null,
  sxdJobDur: null,
  sxdJobDurSure: null,
  isHaveZdFdyJob: null,
  isHaveZdFdyJobTxt: null,
  zdFdyStartTime: null,
  zdFdyEndTime: null,
  schoolMajorKey: null,
  schoolMajorTxt: '请选择',
  salaryKey: null,
  salaryTxt: '请选择',
  titleKey: null,
  titleTxt: '请选择',
  teachSubjectNumKey: null,
  teachSubjectNumTxt: '请选择',
  teachSubjectsKeyArray: [],
  teachSubjectsTxtArray: [],
  isTeachSubjectsMatch: false,
  isHasOtherTeachSubjects: false,
  otherTeachSubject: null,
  classHourNum: 0,
  classHourNumSure: 0,
  zdFdyPxNum: null,
  zdFdyPxNumSure: null,
  zdFdyPxXsNum: null,
  zdFdyPxXsNumSure: null,

  fDaDuifdy: 2,
  fDaDuifdyTxt: '否',

})

const selectSchooleType = (key, value) => {
  states.schoolTypeKey = key;
  states.schoolTypeTxt = value;
  handleSchoolGrade(key);
};
function handleSchoolGrade (key) {
  if (key == 1)(
    states.schoolGradeName = '1-6年级'
  )
  if (key == 2 || key == 5)(
    states.schoolGradeName = '7-9年级'
  )
  if (key == 3 || key == 4)(
    states.schoolGradeName = '1-9年级'
  )
  states.ruduiPiciKey = null;
  states.ruduiPiciTxt = null;
  states.isHljPeiFa = null;
  states.isHljPeiFaTxt = null;
}
const selectSchooleArea = (key, value) => {
  states.schoolAreaKey = key;
  states.schoolAreaTxt = value;
};
// const sdhDateDisplay = ref(states.sdhDateTxt ? format(states.sdhDateTxt, 22) : "年/月");
const sdhDateDisplay = ref("年/月");
const SdhList = [{
    key: 1,
    value: sdhDateDisplay
}, {
    key: 2,
    value: '未开过'
}];
//编辑模式获取到API数据后调用：初始化sdhDateDisplay显示, 
function setSdhDateDisplay(){
  if(states.sdhDateTxt !== '未开过'){
    sdhDateDisplay.value = ref(states.sdhDateTxt ? format(states.sdhDateTxt, 6) : "年/月");
  }
}
const selectRuduiPici = (key, value) => {
  states.ruduiPiciKey = key;
  states.ruduiPiciTxt = value;
};
const handleHljJzRadioChange = () => {
  states.isHljJzActivityTxt = format(states.isHljJzActivity, 1);
};
const handleSfsRadioChange = () => {
  states.isSfsTxt = format(states.isSfs, 1);
};
const handleHljPeiFaRadioChange = () => {
  states.isHljPeiFaTxt = format(states.isHljPeiFa, 1);
};

const fDaDuifdyDisplay = ref("是");
const FDaDuifdyList = [{
    key: 2,
    value: '否'
},{
    key: 1,
    value: fDaDuifdyDisplay
}];

const fDaDuifdySelectRef = ref(null);
const handleFDaDuifdyRadioChange = (value) => {
  // 处理单选按钮变化的事件，如果需要的话
  if (value == 1){
    fDaDuifdySelectRef.value.showPopup();
  }
  if (value == 2){
    states.fDaDuifdyTxt = "否";
    fDaDuifdyDisplay.value = "是";
  }
};
const selectfDaDuifdy = (key, value) => {
  states.fDaDuifdyTxt = value;
  fDaDuifdyDisplay.value = value;
};

function handleFDaDuifdyCancel () {
  if (states.fDaDuifdyTxt == '否') {
    states.fDaDuifdy = 2;
  }
  if(states.fDaDuifdy == 1 && !states.fDaDuifdyTxt) {
    states.fDaDuifdy = 2;
    states.fDaDuifdyTxt = '否'
  }
}
const sxdClassDisplay = ref("是");
const SxdClassList = [{
    key: 1,
    value: sxdClassDisplay
}, {
    key: 2,
    value: '否'
}];
//编辑模式获取到API数据后调用：初始化sdhDateDisplay显示, 
function setSxdClassDisplay(){
  if(states.sxdClassDateTxt !== '否'){
    sxdClassDisplay.value = states.sxdClassDateTxt;
  }
}
const sxdGhdDisplay = ref("是");
const SxdGhdList = [{
    key: 1,
    value: sxdGhdDisplay
}, {
    key: 2,
    value: '否'
}];
//编辑模式获取到API数据后调用：初始化sdhDateDisplay显示, 
function setSxdGhdDisplay(){
  if(states.sxdGhdDateTxt !== '否'){
    sxdGhdDisplay.value = states.sxdGhdDateTxt;
  }
}
const selectSxdHdk = (key, value) => {
  states.sxdHdkKey = key;
  states.sxdHdkTxt = value;
};
const selectSgwZhuRen = (key, value) => {
  states.sgwZhuRenkey = key;
  states.sgwZhuRenTxt = value;
};
const selectZzmm = (key, value) => {
  states.zzmmkey = key;
  states.zzmmTxt = value;
};
const selectDaDuiFdyTpye = (key, value) => {
  states.daDuiFdyTpyeKey = key;
  states.daDuiFdyTpyeTxt = value;
};
// 身份证号验证函数
const validateIdCard = (val) => {
  // 检查长度是否为18位
  if (val.length !== 18) {
    return false;
  }
  // 检查前17位是否为数字
  for (let i = 0; i < 17; i++) {
    if (!/^\d$/.test(val.charAt(i))) {
      return false;
    }
  }
  // 检查第18位是否为数字或X（不区分大小写）
  if (!/^\d$|^[Xx]$/.test(val.charAt(17))) {
    return false;
  }
  // 加权因子和校验
  const weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
  const checkCodes = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
  let sum = 0;
  for (let i = 0; i < 17; i++) {
    sum += parseInt(val.charAt(i), 10) * weights[i];
  }
  const mod = sum % 11;
  const expectedCheckCode = checkCodes[mod];
  // 注意：这里需要比较的是val的第18位（转换为大写）与expectedCheckCode
  return val.charAt(17).toUpperCase() === expectedCheckCode;
};
//输入验证：身份证合法性验证
const idCardFormatDifferent = ref(false);
const errorMessageIdCardFormat = ref('');
const validateInputIdCardFormat = () => {
  if (!validateIdCard(states.daDuiFdyIdCard)){
    idCardFormatDifferent.value = true;
    errorMessageIdCardFormat.value = '请输入合法的18位身份证号';
  }else{
    idCardFormatDifferent.value = false;
    errorMessageIdCardFormat.value = '';
  }
};
//输入验证：身份证确认验证
const idCardDifferent = ref(false);
const errorMessageIdCard = ref('');
const validateInputsIdCard = () => {
  // 检查两个输入字段的值是否一致
  if (states.daDuiFdyIdCard !== states.daDuiFdyIdCardSure) {
    idCardDifferent.value = true;
    errorMessageIdCard.value = '身份证两次输入不一致';
  } else {
    idCardDifferent.value = false;
    errorMessageIdCard.value = '';
  }
};
const selectDaDuiFdyZzmm = (key, value) => {
  states.daDuiFdyZzmmKey = key;
  states.daDuiFdyZzmmTxt = value;
};
const selectEdu = (key, value) => {
  states.eduKey = key;
  states.eduTxt = value;
};
const selectMajor = (key, value) => {
  states.majorKey = key;
  states.majorTxt = value;
};
const selectCollege = (key, value) => {
  states.collegeKey = key;
  states.collegeTxt = value;
  if(states.collegeKey == -1){
    states.collegeTxt = null;
  }
};
const handleGatOrAbroadRadioChange = (key) => {
  states.isGatOrAbroad = key;
  states.isGatOrAbroadTxt = format(states.isGatOrAbroad, 1);
  if(states.isGatOrAbroad == 2){
    states.collegeKey = null;
    states.collegeTxt = '请选择';
  }
  if(states.isGatOrAbroad == 1){
    states.collegeKey = null;
    states.collegeTxt = '';
  }
};
const selectHighestEdu = (key, value) => {
  clearHighestPart();
  states.highestEduKey = key;
  states.highestEduTxt = value;
};
const selectHighestMajor = (key, value) => {
  states.highestMajorKey = key;
  states.highestMajorTxt = value;
};

const selectHighestCollege = (key, value) => {
  states.highestCollegeKey = key;
  states.highestCollegeTxt = value;
  if(states.highestCollegeKey == -1){
    states.highestCollegeTxt = null;
  }
};

const selectHighestEduXZ = (key, value) => {
  states.highestEduXZKey = key;
  states.highestEduXZTxt = value;
};

function clearHighestPart() {
  states.isHighestGatOrAbroad = null;
  states.isHighestGatOrAbroadTxt = null;
  states.highestMajorKey = null;
  states.highestMajorTxt = '请选择';
  states.highestCollegeKey = null;
  states.highestCollegeTxt = '请选择';
  states.highestEduXZKey = null;
  states.highestEduXZTxt = '请选择';
}
const handleHighestGatOrAbroadRadioChange = (key) => {
  states.isHighestGatOrAbroad = key;
  states.isHighestGatOrAbroadTxt = format(states.isHighestGatOrAbroad, 1);
  if(states.isHighestGatOrAbroad == 2){
    states.highestCollegeKey = null;
    states.highestCollegeTxt = '请选择';
  }
  if(states.isHighestGatOrAbroad == 1){
    states.highestCollegeKey = null;
    states.highestCollegeTxt = '';
  }
};
const handleHaveTuanRadioChange = () => {
  states.isHaveTuanTxt = format(states.isHaveTuan, 1);
  if(states.isHaveTuan == 2){
    states.isHaveTuanJob = null;
    states.isHaveTuanJobTxt = null;

    states.haveTuanJobMajorKey = null;
    states.haveTuanJobMajorTxt = '请选择';
  }
};
const handleHaveTuanJobRadioChange = () => {
  states.isHaveTuanJobTxt = format(states.isHaveTuanJob, 1);
  if(states.isHaveTuanJob == 2){
    states.haveTuanJobMajorKey = null;
    states.haveTuanJobMajorTxt = '请选择';
  }
};
const selectHaveTuanJobMajor = (key, value) => {
  states.haveTuanJobMajorKey = key;
  states.haveTuanJobMajorTxt = value;
};
const handleHaveZdFdyJobRadioChange = () => {
  states.isHaveZdFdyJobTxt = format(states.isHaveZdFdyJob, 1);
  if(states.isHaveZdFdyJob == 2){
    states.zdFdyStartTime = null;
    states.zdFdyEndTime = null;
  }
};
const handlerZdFdyStartTimeSelect = (key, value) => {
  console.log(key, value);
  states.zdFdyStartTime = value;
  // if (key == "birthday") {
  //   state.birthdayFlag = false;
  // }
  validateTime();
};
const handlerZdFdyEndTimeSelect = (key, value) => {
  console.log(key, value);
  states.zdFdyEndTime = value;
  // if (key == "birthday") {
  //   state.birthdayFlag = false;
  // }
  validateTime();
};
const validateTime = () => {
  const { zdFdyStartTime, zdFdyEndTime } = states;
  if (zdFdyStartTime && zdFdyEndTime && zdFdyEndTime < zdFdyStartTime) {
    tipsMsg("提示", "结束时间不能早于开始时间");
    states.zdFdyEndTime = ''; // 清空错误的结束时间
  }
}
const selectSchoolMajor = (key, value) => {
  states.schoolMajorKey = key;
  states.schoolMajorTxt = value;

  states.salaryKey = null;
  states.salaryTxt = '请选择';
};
const selectSalary = (key, value) => {
  states.salaryKey = key;
  states.salaryTxt = value;
};
const selectTitle = (key, value) => {
  states.titleKey = key;
  states.titleTxt = value;
};
const selectTeachSubjectNum = (key, value) => {
  states.teachSubjectNumKey = key;
  states.teachSubjectNumTxt = value;
  if (states.teachSubjectNumKey == 1){
    states.teachSubjectsKeyArray = [];
    states.teachSubjectsTxtArray = [];
    states.isTeachSubjectsMatch = false;
    states.isHasOtherTeachSubjects = false;
  }
};
const selectTeachSubjects = ({ keys, labels }) => {
  states.teachSubjectsKeyArray = keys;
  states.teachSubjectsTxtArray = labels;
  teachSubjectsMatch();
  hasTeachSubjects();
  if (!states.isTeachSubjectsMatch){
    tipsMsg("提示", "任教学科选择的数量与任教学科门数不一致");
  }
  if (!states.isHasOtherTeachSubjects) {
    states.otherTeachSubject = null;
  }
};

function teachSubjectsMatch(){
  states.isTeachSubjectsMatch = false;
  if(states.teachSubjectNumKey == 1 && states.teachSubjectsKeyArray.length == 0){
    states.isTeachSubjectsMatch = true;
  }
  if(states.teachSubjectNumKey == 2 && states.teachSubjectsKeyArray.length == 1){
    states.isTeachSubjectsMatch = true;
  }
  if(states.teachSubjectNumKey == 3 && states.teachSubjectsKeyArray.length == 2){
    states.isTeachSubjectsMatch = true;
  }
  if(states.teachSubjectNumKey == 4 && states.teachSubjectsKeyArray.length == 3){
    states.isTeachSubjectsMatch = true;
  }
  if(states.teachSubjectNumKey == 5 && states.teachSubjectsKeyArray.length == 4){
    states.isTeachSubjectsMatch = true;
  }
  if(states.teachSubjectNumKey == 6 && states.teachSubjectsKeyArray.length >= 5){
    states.isTeachSubjectsMatch = true;
  }
}

function hasTeachSubjects(){
  states.isHasOtherTeachSubjects = false;
  if(states.teachSubjectsKeyArray.includes(10)){
    states.isHasOtherTeachSubjects = true;
  }
}

//输入验证：中队数量
const zhongDuiInputsDifferent = ref(false);
const zhongDuiErrorMessage = ref('');
const zhongDuiValidateInputs = () => {
  // 检查两个输入字段的值是否一致
  if (states.zhongDuiNum !== states.zhongDuiNumSure) {
    zhongDuiInputsDifferent.value = true;
    zhongDuiErrorMessage.value = '两次输入不一致，请确认';
  } else {
    zhongDuiInputsDifferent.value = false;
    zhongDuiErrorMessage.value = '';
  }
};
//输入验证：少先队员人数
const shaoXianDuiInputsDifferent = ref(false);
const shaoXianDuiErrorMessage = ref('');
const shaoXianDuiValidateInputs = () => {
  // 检查两个输入字段的值是否一致
  if (states.shaoXianDuiPeopleNum !== states.shaoXianDuiPeopleNumSure) {
    shaoXianDuiInputsDifferent.value = true;
    shaoXianDuiErrorMessage.value = '两次输入不一致，请确认';
  } else {
    shaoXianDuiInputsDifferent.value = false;
    shaoXianDuiErrorMessage.value = '';
  }
};
//输入验证: 校验本校学生数大于等于少先队员人数
const schoolGradePeopleNumErr = ref(false);
const schoolGradePeopleNumErrorMessage = ref('');
const onSchoolGradePeopleNumBlur = () => {
  // 检查两个输入字段的值是否一致
  if (states.schoolGradePeopleNum && Number(states.schoolGradePeopleNum) < states.shaoXianDuiPeopleNum) {
    schoolGradePeopleNumErr.value = true;
    schoolGradePeopleNumErrorMessage.value = `学生人数不能小于少先队员人数（${states.shaoXianDuiPeopleNum}）`;
  } else {
    schoolGradePeopleNumErr.value = false;
    schoolGradePeopleNumErrorMessage.value = '';
  }
};

//输入验证：本校x-x年级学生数
const schoolGradePeopleInputsDifferent = ref(false);
const schoolGradePeopleErrorMessage = ref('');
const schoolGradePeopleValidateInputs = () => {
  // 检查两个输入字段的值是否一致
  if (states.schoolGradePeopleNum !== states.schoolGradePeopleNumSure) {
    schoolGradePeopleInputsDifferent.value = true;
    schoolGradePeopleErrorMessage.value = '两次输入不一致，请确认';
  } else {
    schoolGradePeopleInputsDifferent.value = false;
    schoolGradePeopleErrorMessage.value = '';
  }
};
//输入验证：学校少工委主任姓名
const sgwZhuRenNameInputsDifferent = ref(false);
const sgwZhuRenNameErrorMessage = ref('');
const sgwZhuRenNameValidateInputs = () => {
  // 检查两个输入字段的值是否一致
  if (states.sgwZhuRenName !== states.sgwZhuRenNameSure) {
    sgwZhuRenNameInputsDifferent.value = true;
    sgwZhuRenNameErrorMessage.value = '两次输入不一致，请确认';
  } else {
    sgwZhuRenNameInputsDifferent.value = false;
    sgwZhuRenNameErrorMessage.value = '';
  }
};
//输入验证：手机号格式验证
const PhoneFormatDifferent = ref(false);
const errorMessagePhoneFormat = ref('');
const validateInputsPhoneFormat = () => {
  if (states.phone.length != 11) {
    PhoneFormatDifferent.value = true;
    errorMessagePhoneFormat.value = '请输入11位手机号';
  } else {
    PhoneFormatDifferent.value = false;
    errorMessagePhoneFormat.value = '';
  }
};
//输入验证：手机号
const PhoneDifferent = ref(false);
const errorMessagePhone = ref('');
const validateInputsPhone = () => {
  // 检查两个输入字段的值是否一致
  if (states.phone !== states.phoneSure) {
    PhoneDifferent.value = true;
    errorMessagePhone.value = '两次输入不一致，请确认';
  } else {
    PhoneDifferent.value = false;
    errorMessagePhone.value = '';
  }
};
//输入验证：大队辅导员手机号格式验证
const daDuiFdyPhoneFormatDifferent = ref(false);
const errorMessageDaDuiFdyPhoneFormat = ref('');
const validateInputsDaDuiFdyPhoneFormat = () => {
  if (states.daDuiFdyPhone.length != 11) {
    daDuiFdyPhoneFormatDifferent.value = true;
    errorMessageDaDuiFdyPhoneFormat.value = '请输入11位手机号';
  } else {
    daDuiFdyPhoneFormatDifferent.value = false;
    errorMessageDaDuiFdyPhoneFormat.value = '';
  }
};
//输入验证：大队辅导员手机号
const daDuiFdyPhoneDifferent = ref(false);
const errorMessagedaDuiFdyPhone = ref('');
const validateInputsdaDuiFdyPhone = () => {
  // 检查两个输入字段的值是否一致
  if (states.daDuiFdyPhone !== states.daDuiFdyPhoneSure) {
    daDuiFdyPhoneDifferent.value = true;
    errorMessagedaDuiFdyPhone.value = '两次输入不一致，请确认';
  } else {
    daDuiFdyPhoneDifferent.value = false;
    errorMessagedaDuiFdyPhone.value = '';
  }
};

//输入验证：累计从事少先队工作年数
const sxdJobDurDifferent = ref(false);
const errorMessageSxdJobDur = ref('');
const validateInputSxdJobDur = () => {
  // 检查两个输入字段的值是否一致
  if (states.sxdJobDur !== states.sxdJobDurSure) {
    sxdJobDurDifferent.value = true;
    errorMessageSxdJobDur.value = '两次输入不一致，请确认';
  } else {
    sxdJobDurDifferent.value = false;
    errorMessageSxdJobDur.value = '';
  }
};

//输入验证：每周课时数
const classHourNumDifferent = ref(false);
const errorMessageClassHourNum = ref('');
const validateInputClassHourNum = () => {
  // 检查两个输入字段的值是否一致
  if (states.classHourNum !== states.classHourNumSure) {
    classHourNumDifferent.value = true;
    errorMessageClassHourNum.value = '两次输入不一致，请确认';
  } else {
    classHourNumDifferent.value = false;
    errorMessageClassHourNum.value = '';
  }
};

//输入验证：2024年度本校中队辅导员参加培训的人数
const zdFdyPxDifferent = ref(false);
const errorMessageZdFdyPx = ref('');
const validateInputZdFdyPx = () => {
  // 检查两个输入字段的值是否一致
  if (states.zdFdyPxNum !== states.zdFdyPxNumSure) {
    zdFdyPxDifferent.value = true;
    errorMessageZdFdyPx.value = '两次输入不一致，请确认';
  } else {
    zdFdyPxDifferent.value = false;
    errorMessageZdFdyPx.value = '';
  }
};

//输入验证：2024年度本校中队辅导员参加互联网线上培训的人数
const zdFdyPxXsDifferent = ref(false);
const errorMessagezdFdyPxXs = ref('');
const validateInputZdFdyPxXs = () => {
  // 检查两个输入字段的值是否一致
  if (states.zdFdyPxXsNum !== states.zdFdyPxXsNumSure) {
    zdFdyPxXsDifferent.value = true;
    errorMessagezdFdyPxXs.value = '两次输入不一致，请确认';
  } else {
    zdFdyPxXsDifferent.value = false;
    errorMessagezdFdyPxXs.value = '';
  }
};

// 选择字段回调赋值
const handlerSelect = (key, value) => {
  console.log(key, value);
  states.sdhDateTxt = value;
  // sdhDateDisplay.value = format(states.sdhDateTxt, 22); 格式化：年-月-日
  sdhDateDisplay.value = format(states.sdhDateTxt, 6);

  console.log("meeting--sdhDate", states.sdhDate);
  console.log("meeting--sdhDateTxt", states.sdhDateTxt);
  // console.log("meeting--sdhDateDisplay", sdhDateDisplay.value);
  if (key == "meetingData") {
    showPopup()
  }
};

function handleCancel () {
  if (states.sdhDateTxt == '未开过') {
    states.sdhDate = 2;
  }
}

// 选择字段回调赋值
const handlerDaDuiFdySelect = (key, value) => {
  console.log(key, value);
  states.daDuiFdyBirthday = value;
  // if (key == "birthday") {
  //   state.birthdayFlag = false;
  // }
};
const handlerFdyStartTimeySelect = (key, value) => {
  console.log(key, value);
  states.fdyStartTime = value;
  // if (key == "birthday") {
  //   state.birthdayFlag = false;
  // }
};
const isDatePickerVisible = ref(false);
function showDatePicker() {
  isDatePickerVisible.value = true;
}

function hideDatePicker() {
  isDatePickerVisible.value = false;
}

const showPopup = () => {
  isDatePickerVisible.value = !isDatePickerVisible.value;
};

const handleRadioChange = (value) => {
  // 处理单选按钮变化的事件，如果需要的话
  if (value == 1){
    showDatePicker();
  }
  if (value == 2){
    hideDatePicker();
    states.sdhDateTxt = "未开过";
    sdhDateDisplay.value = "年/月";
  }
};

const selectRef = ref(null);
const handleSxdClassRadioChange = (value) => {
  // 处理单选按钮变化的事件，如果需要的话
  if (value == 1){
    selectRef.value.showPopup();
  }
  if (value == 2){
    states.sxdClassDateTxt = "否";
    sxdClassDisplay.value = "是";
  }
};
function handleSxdClassCancel () {
  if (states.sxdClassDateTxt == '否') {
    states.sxdClassDate = 2;
  }
  if(states.sxdClassDate == 1 && !states.sxdClassDateTxt) {
    states.sxdClassDate = 2;
    states.sxdClassDateTxt = '否'
  }
}

const selectSxdClass = (key, value) => {
  states.sxdClassDateTxt = value;
  sxdClassDisplay.value = value;
};

const selectGhdRef = ref(null);
const handleSxdGhdRadioChange = (value) => {
  // 处理单选按钮变化的事件，如果需要的话
  if (value == 1){
    selectGhdRef.value.showPopup();
  }
  if (value == 2){
    states.sxdGhdDateTxt = "否";
    sxdGhdDisplay.value = "是";
  }
};
function handleSxdGhdCancel () {
  if (states.sxdGhdDateTxt == '否') {
    states.sxdGhdDate = 2;
  }
  if(states.sxdGhdDate == 1 && !states.sxdGhdDateTxt) {
    states.sxdGhdDate = 2;
    states.sxdGhdDateTxt = '否'
  }
}

const selectSxdGhd = (key, value) => {
  states.sxdGhdDateTxt = value;
  sxdGhdDisplay.value = value;
};

const onClickButtonSubmit = async () => {
  if (!states.schoolTypeKey) {
    tipsMsg("提示", "请选择学校类型");
    return false;
  }
  if (!states.schoolAreaKey) {
    tipsMsg("提示", "请选择学校所处区域");
    return false;
  }
  if (states.zhongDuiNum !== states.zhongDuiNumSure)  {
    tipsMsg("提示", "两次中队数量输入不一致");
    return false;
  }
  if (states.shaoXianDuiPeopleNum !== states.shaoXianDuiPeopleNumSure)  {
    tipsMsg("提示", "两次少先队员人数输入不一致");
    return false;
  }
  if (states.schoolGradePeopleNum && Number(states.schoolGradePeopleNum) < states.shaoXianDuiPeopleNum)  {
    tipsMsg("提示", "学生人数不能小于少先队员人数");
    return false;
  }
  if (states.schoolGradePeopleNum !== states.schoolGradePeopleNumSure)  {
    tipsMsg("提示", "两次年级学生数输入不一致");
    return false;
  }
  if (states.schoolTypeKey != 2 && states.schoolTypeKey != 5 && !states.ruduiPiciKey) {
    tipsMsg("提示", "请选择学校学生分几批次入队");
    return false;
  }
  if (!states.sxdHdkKey) {
    tipsMsg("提示", "请选择少先队活动课课时安排情况");
    return false;
  }
  if (!states.sgwZhuRenkey) {
    tipsMsg("提示", "请选择学校少工委主任由谁来担任");
    return false;
  }
  if(states.sgwZhuRenkey != 6) {
    if (states.sgwZhuRenName !== states.sgwZhuRenNameSure)  {
      tipsMsg("提示", "两次学校少工委主任姓名输入不一致");
      return false;
    }
    if (!states.zzmmkey) {
      tipsMsg("提示", "请选择政治面貌");
      return false;
    }
    if (states.phone !== states.phoneSure)  {
      tipsMsg("提示", "两次手机号输入不一致");
      return false;
    }
  }
  

 
  if (!states.daDuiFdyTpyeKey) {
    tipsMsg("提示", "请选择大队辅导员身份类型");
    return false;
  }
  if (!states.daDuiFdyBirthday) {
    tipsMsg("提示", "请选择大队辅导员出生年月");
    return false;
  }
  if (!states.daDuiFdyZzmmKey) {
    tipsMsg("提示", "请选择大队辅导员政治面貌");
    return false;
  }
  if (states.daDuiFdyPhone !== states.daDuiFdyPhoneSure)  {
    tipsMsg("提示", "两次手机号输入不一致");
    return false;
  }
  if (!states.eduKey) {
    tipsMsg("提示", "请选择全日制教育学历");
    return false;
  }
  if (!states.majorKey) {
    tipsMsg("提示", "请选择所学专业大类");
    return false;
  }
  if (states.isGatOrAbroad == 2 && !states.collegeKey) {
    tipsMsg("提示", "请选择毕业院校");
    return false;
  }
  if (!states.highestEduKey) {
    tipsMsg("提示", "请选择最高教育学历");
    return false;
  }
  if (states.highestEduKey !== 1)  {
    if(!states.highestMajorKey){
      tipsMsg("提示", "请选择最高教育学历所学专业大类");
      return false;
    }
    if(states.isHighestGatOrAbroad == 2 && !states.highestCollegeKey){
      tipsMsg("提示", "请选择最高教育学历毕业院校");
      return false;
    }
    if(!states.highestEduXZKey){
      tipsMsg("提示", "请选择最高教育学历性质");
      return false;
    }
  }
  if (states.isHaveTuanJob == 1 && !states.haveTuanJobMajorKey) {
    tipsMsg("提示", "请选择兼任校内团干部职务");
    return false;
  }
  if(!states.fdyStartTime){
      tipsMsg("提示", "请选择任本校大队辅导员开始时间");
      return false;
    }
  if (states.sxdJobDur !== states.sxdJobDurSure)  {
    tipsMsg("提示", "两次累计从事少先队工作年数输入不一致");
    return false;
  }
  if (states.isHaveZdFdyJob == 1 && !states.zdFdyStartTime) {
    tipsMsg("提示", "请选择担任中队辅导员开始时间");
    return false;
  }
  if (states.isHaveZdFdyJob == 1 && !states.zdFdyEndTime) {
    tipsMsg("提示", "请选择担任中队辅导员结束时间");
    return false;
  }
  // 添加校验逻辑：结束时间不得早于开始时间
  if (states.isHaveZdFdyJob == 1 && states.zdFdyStartTime && states.zdFdyEndTime) {
    if (states.zdFdyEndTime < states.zdFdyStartTime) {
      tipsMsg("提示", "结束时间不能早于开始时间");
      return false;
    }
  }
  if(!states.schoolMajorKey){
    tipsMsg("提示", "请选择校内职务");
    return false;
  }
  if(!states.schoolMajorKey){
    tipsMsg("提示", "请选择校内职务");
    return false;
  }
  if((states.schoolMajorKey == 4 || states.schoolMajorKey == 5 || states.schoolMajorKey == 6) && !states.salaryKey){
    tipsMsg("提示", "请选择享受待遇");
    return false;
  }
  if(!states.titleKey){
    tipsMsg("提示", "请选择职称");
    return false;
  }
  if(!states.teachSubjectNumKey){
    tipsMsg("提示", "请选择任教学科门数");
    return false;
  }
  if(states.teachSubjectNumKey != 1 && states.teachSubjectsKeyArray.length == 0){
    tipsMsg("提示", "请选择任教学科");
    return false;
  }
  if (states.teachSubjectNumKey != 1 && !states.isTeachSubjectsMatch){
    tipsMsg("提示", "任教学科选择的数量与任教学科门数不一致");
    return false;
  }
  if (states.classHourNum !== states.classHourNumSure)  {
    tipsMsg("提示", "两次每周课时数输入不一致");
    return false;
  }
  if (states.zdFdyPxNum !== states.zdFdyPxNumSure)  {
    tipsMsg("提示", "两次2024年度本校中队辅导员参加线下培训的人数输入不一致");
    return false;
  }
  if (states.zdFdyPxXsNum !== states.zdFdyPxXsNumSure)  {
    tipsMsg("提示", "两次2024年度本校中队辅导员参加互联网线上培训的人数输入不一致");
    return false;
  }
  
  Dialog.confirm({
    title: "提示",
    message: "你确定要提交吗？",
  })
    .then(() => {
      proxy.$showLoading();
      // states.zzmmTxt = format(states.zzmm, 21);
      states.daDuiFdySexTxt = format(states.daDuiFdySex, 12);
      // states.isHljXjtTxt = format(states.isHljXjt, 1);
      add(states);
    })
    .catch(() => {
      // on cancel
    });  
};
const add = async (values) => {
  let arr = [];
  const { id, type } = route.query;
  let data = {
    formId: 38,
    list: [],
  };

  let fn = addForm;
  if (type == 1) {
    data.id = id;
    fn = editForm;
    console.log("editForm---", "editForm---");
  }

  // const whiteList = [
  //   "schoolTypeFlag",
  //   "schoolTypeTxt",
  //   "rules",
  //   "birthdayFlag",
  //   "counselorTimeFlag",
  //   "sdhsjFlag",
  // ];

  for (let i in values) {
    let val = values[i];
    if (i == "daDuiFdyBirthday" && values[i] && values[i].toString().length > 10) {
      val = val / 1000;
      values[i] = val;
    }
    if (i == "fdyStartTime" && values[i] && values[i].toString().length > 10) {
      val = val / 1000;
      values[i] = val;
    }
    if (i == "zdFdyStartTime" && values[i] && values[i].toString().length > 10) {
      val = val / 1000;
      values[i] = val;
    }
    if (i == "zdFdyEndTime" && values[i] && values[i].toString().length > 10) {
      val = val / 1000;
      values[i] = val;
    }
  }

  for (const item in values) {
    let obj = {
      fieldCode: item,
      value: values[item],
    };
    // if (whiteList.indexOf(item) !== -1) {
    //   continue;
    // }
    if (values[item] !== "请选择" && (values[item] || values[item] == 0)) {
      arr.push(obj);
    }
  }
  data.list = arr;

  //随机获取AES的key
  let aesKey = getKey().toLowerCase();
  let param = {
    encryptData: encrypt(data, aesKey), //AES加密后的数据
    encrypted: rsaUtil.encrypt(aesKey, serverPublicKey), //后端RSA公钥加密后的AES的key
    // publicKey: window.jsPublicKey //前端公钥
  };

  try {
    const res = await fn(param);
    console.log("res -> ", data);
    if (res.code === 10000) {
      proxy.$closeLoading();
      Dialog.alert({
        message: "提交成功",
      }).then(() => {
        goTo();
      });
    } else {
      proxy.$closeLoading();
    }
  } catch (error) {
    proxy.$closeLoading();
    console.log("res error -> ", error);
  }
}
const goTo = () => {
  // const { id, url } = route.query;
  // if (id) {
  router.push({ path: "/info/xtj" });
  // }
};
const goBack = () => {
  router.go(-1);
};
const errors = ref(null);
const errorsMsg = ref([]);
const handleFailed = (errorInfo) => {
  errors.value = errorInfo;
  errorsMsg.value = errors.value.errors;
  if(errorsMsg.value && errorsMsg.value.length > 0){
    tipsMsg("提示", errorsMsg.value[0].message);
  }
};
onMounted(async () => {
  const { type } = route.query;
  if (type == 1) {
    getInfo();
  }
});
const getInfo = async () => {
  const { id } = route.query;
  const result = await getsubmitData({ dataId: id });
  const { code, data } = result;
  console.log("data ->", data);
  if (code == 10000 && data) {
    const newObj = {};
    for (const i of data.list) {
      let val = i.value;
      // if (i.fieldCode == "schoolType") {
      //   const st = schoolTypes.filter((r) => r.key == i.value);
      //   if (st.length > 0) {
      //     state.schoolTypeTxt = st[0].value;
      //   }
      // }
      if (
        i.fieldCode == "daDuiFdyBirthday"
      ) {
        val = val * 1000;
      }
      if (
        i.fieldCode == "fdyStartTime"
      ) {
        val = val * 1000;
      }
      if (
        i.fieldCode == "zdFdyStartTime"
      ) {
        val = val * 1000;
      }
      if (
        i.fieldCode == "zdFdyEndTime"
      ) {
        val = val * 1000;
      }
      
      newObj[i.fieldCode] = val;
    }
    //   赋值
    Object.assign(states, newObj);
    setSdhDateDisplay();
    setSxdClassDisplay();
    setSxdGhdDisplay();
  }
};
</script>

<style lang="less" scoped>
// @import "../../../common/style/mixin";
.radioStyle {
  background-color: #f90;
}

.back_left {
  width: 10%;
  height: 0.883rem;
  position: absolute;
  top: 0.233rem;
  left: 0.133rem;
  z-index: 99;
}
.go_back {
  height: 0.383rem;
  padding: 0.033rem 0 0 0.333rem;
  overflow: visible;
  color: rgb(255, 255, 255);
  font-size: 28px;
  z-index: 99;
}
.custom-cell-title {
  font-weight: bold;
  font-size: 16px;
}
:deep(.van-field__control--custom) {
  display: block;
}
.radioFlex :deep(.van-field__control--custom) {
  display: flex;
}

:deep(.van-cell__value),
:deep(.van-field__control),
:deep(.van-cell__right-icon) {
  color: #ff6865;
}
:deep(.van-radio__icon .van-icon) {
  border: 0.02667rem solid #ff6865 !important;
}
:deep(.van-cell__title) {
  color: #646566;
}
:deep(.van-radio-group) {
  padding: 0.168rem 0;
}
.title {
  text-align: center;
  font-size: 17px;
  margin-top: 10px;
  .tip {
    font-size: 12px;
  }
}
.fz-bold {
  font-weight: bold !important;
  color: red;
}
.d_f{
  display: flex;
  flex-direction: column;
}
.d_f :deep(.van-field__label) {
  width: 100%;
}
.d_f :deep(.van-field__body) {
  margin-top: 10px;
}
</style>
